/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';

class Header extends Component {
  render() {
    const { thumbnail } = this.props;
    const { author } = this.props;
    return (
      <header>
        <div className="left-header">
          <div className="post-icon">
            <img src={thumbnail} alt="user icon" />
          </div>
          <p>
            <a href="#">{author}</a>
          </p>
        </div>
        <div className="right-header">
          {/* <!-- make this a button alert some day --> */}
          <button className="report-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="15"
              height="15"
              viewBox="0 0 50 50"
              style={{ fill: '#000000' }}
            >
              <path d="M 8 20 C 4.6875 20 2 22.6875 2 26 C 2 29.3125 4.6875 32 8 32 C 11.3125 32 14 29.3125 14 26 C 14 22.6875 11.3125 20 8 20 Z M 25 20 C 21.6875 20 19 22.6875 19 26 C 19 29.3125 21.6875 32 25 32 C 28.3125 32 31 29.3125 31 26 C 31 22.6875 28.3125 20 25 20 Z M 42 20 C 38.6875 20 36 22.6875 36 26 C 36 29.3125 38.6875 32 42 32 C 45.3125 32 48 29.3125 48 26 C 48 22.6875 45.3125 20 42 20 Z"></path>
            </svg>
          </button>
        </div>
      </header>
    );
  }
}

export default Header;
